"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _redux = require("redux");
var _level1Reducer = _interopRequireDefault(require("./reducers/level1Reducer"));
var _level2Reducer = _interopRequireDefault(require("./reducers/level2Reducer"));
var _positionReducer = _interopRequireDefault(require("./reducers/positionReducer"));
var _instrumentReducer = _interopRequireDefault(require("./reducers/instrumentReducer"));
var _productReducer = _interopRequireDefault(require("./reducers/productReducer"));
var _orderHistoryReducer = _interopRequireDefault(require("./reducers/orderHistoryReducer"));
var _baseNotionalProductReducer = _interopRequireDefault(require("./reducers/baseNotionalProductReducer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var apexCore = (0, _redux.combineReducers)({
  level1: _level1Reducer["default"],
  level2: _level2Reducer["default"],
  position: _positionReducer["default"],
  instrument: _instrumentReducer["default"],
  product: _productReducer["default"],
  orderHistory: _orderHistoryReducer["default"],
  baseNotionalProduct: _baseNotionalProductReducer["default"]
});
var _default = exports["default"] = apexCore;